import pMap from 'p-map';
import JSZip from 'jszip';
import contentDisposition from 'content-disposition';
import { get, getRaw, downloadBlob } from '../lib/api';

export async function getFields(growerId) {
  const fields = await get(`/${growerId}/soil-report/fields`);
  return fields.map((field) => ({ aaManagedId: field.aaid, ...field }));
}

export async function generateReport(grower, interpolations, setProgress) {
  const ids = interpolations.map((i) => i.id);

  const reports = ids.map((id) => ({
    id,
    url: `soil/${grower.guid}/pdf?id=${id}`,
  }));

  reports.push({
    id: 'summary',
    url: `soil-summary/${grower.guid}/pdf?id=${ids.join()}`,
  });

  const zip = await buildZipLocally(reports, setProgress);

  return {
    data: await zip.generateAsync({ type: 'blob' }),
    headers: {
      'content-disposition': `attachment; filename="${grower.operationName} Soil Reports.zip"`,
    },
  };
}

async function buildZipLocally(reports, setProgress) {
  let done = 0;
  const showProgress = () => setProgress((done / reports.length) * 100);
  showProgress();

  const zip = new JSZip();

  await pMap(
    reports,
    async ({ url, id }) => {
      const response = await getRaw(url, { responseType: 'arraybuffer' });
      const filename = getFilename(response) || `${id}.pdf`;
      zip.file(filename, response.data, { binary: true });
      done += 1;
      showProgress();
    },
    { concurrency: 4 },
  );

  return zip;

  function getFilename(response) {
    const contentDispositionHeader = response.headers['content-disposition'];

    if (contentDispositionHeader) {
      const { parameters } = contentDisposition.parse(contentDispositionHeader);
      return parameters?.filename;
    }
  }
}

export async function generateCsv(grower, interpolations) {
  const ids = interpolations.map((i) => i.id);
  return downloadBlob(`/${grower.guid}/soil-report/csv?id=${ids.join()}`);
}

export async function generateShapefile(grower, interpolations) {
  const ids = interpolations.map((i) => i.id);
  return downloadBlob(`/soil-report/${grower.guid}/shapefile?id=${ids.join()}`);
}
